import tmhRequest from '@/config/tmhRequest'

export default {
    searchCustomerClassifyDetailReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/customerclassifydetailreport/searchcustomerclassifydetailreportcount',
            method: 'post',
            data: data,
        })
    },
    searchCustomerClassifyDetailReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/customerclassifydetailreport/searchcustomerclassifydetailreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportCustomerClassifyReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/customerclassifyreport/exportcustomerclassifyreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/customerclassifydetailreport.js